import { render, staticRenderFns } from "./FormEventMain.vue?vue&type=template&id=aa2ae884&"
import script from "./FormEventMain.vue?vue&type=script&lang=js&"
export * from "./FormEventMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2ae884')) {
      api.createRecord('aa2ae884', component.options)
    } else {
      api.reload('aa2ae884', component.options)
    }
    module.hot.accept("./FormEventMain.vue?vue&type=template&id=aa2ae884&", function () {
      api.rerender('aa2ae884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/main/FormEventMain.vue"
export default component.exports